import React, { PropTypes } from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import AccessibleDatePicker from '@bibliocommons/base-accessibility-date-picker';
import { PrimaryGhostButton } from '@bibliocommons/base-buttons';
import { CalendarEmpty } from '@bibliocommons/base-icons';
import ShortFormattedDate from '../../../shared/ShortFormattedDate';

import './HoldsPauseDateSelect.scss';

const getTomorrow = () =>
  moment().add(1, 'day').format('YYYY-MM-DD');


export default class HoldsPauseDateSelect extends BcReactComponent {
  constructor(props) {
    super(props);
    let startDate = null;
    if (this.props.enableStartDate) {
      startDate = props.initialSuspendStartDate ? props.initialSuspendStartDate : moment().format('YYYY-MM-DD');
    }
    const endDate = props.initialSuspendEndDate ? props.initialSuspendEndDate : null;
    this.state = {
      openStartDateOverlay: false,
      openEndDateOverlay: false,
      suspended: {
        startDate,
        endDate,
        status: false
      }
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { startDate, endDate } = this.state.suspended;

    if (startDate !== prevState.suspended.startDate || endDate !== prevState.suspended.endDate) {
      this.props.onSelectDates(this.state.suspended);
    }
    return null;
  }

  renderPauseStartDatePickerOverlay() {
    const { openStartDateOverlay } = this.state;
    const { startDate } = this.state.suspended;
    const date = startDate || getTomorrow();

    return (
      <div className="suspend-start-date-field item-row">
        <FormattedMessage id="pause_holds_from" />
        <AccessibleDatePicker
          open={openStartDateOverlay}
          className="start-date"
          fullScreen={this.props.fullScreen}
          initialDate={date}
          handleClose={() => this.setState({ openStartDateOverlay: false })}
          isOutsideRange={(day) => {
            const isBeforeToday = day.isBefore(moment(), 'day');

            if (this.state.suspended.endDate) {
              const isBeforeEnd = day.isBefore(this.state.suspended.endDate, 'day');
              return !isBeforeEnd || isBeforeToday;
            }

            return isBeforeToday;
          }}
          onDateChange={fromDate => this.setState({ suspended: { ...this.state.suspended, startDate: fromDate } })}>
          <PrimaryGhostButton handleClick={() => this.setState({ openStartDateOverlay: true })}>
            <CalendarEmpty />
            <ShortFormattedDate value={date} />
          </PrimaryGhostButton>
        </AccessibleDatePicker>
      </div>
    );
  }

  renderPauseEndDatePickerOverlay() {
    const { openEndDateOverlay } = this.state;
    const { endDate } = this.state.suspended;
    const date = endDate;

    return (
      <div className="suspend-end-date-field item-row">
        <FormattedMessage id="pause_holds_until" />
        <AccessibleDatePicker
          open={openEndDateOverlay}
          className="end-date"
          fullScreen={this.props.fullScreen}
          initialDate={date}
          isOutsideRange={(day) => {
            const isAfterToday = day.isAfter(moment(), 'day');

            if (this.state.suspended.startDate) {
              const isAfterStart = day.isAfter(this.state.suspended.startDate, 'day');
              return !isAfterStart || !isAfterToday;
            }

            return !isAfterToday;
          }}
          handleClose={() => this.setState({ openEndDateOverlay: false })}
          onDateChange={untilDate => this.setState({ suspended: { ...this.state.suspended, endDate: untilDate } })}>
          <PrimaryGhostButton handleClick={() => this.setState({ openEndDateOverlay: true })}>
            <CalendarEmpty />
            {date ? <ShortFormattedDate value={date} /> : <FormattedMessage id="select_a_date" />}
          </PrimaryGhostButton>
        </AccessibleDatePicker>
      </div>
    );
  }

  render () {
    const { enableStartDate, enableEndDate } = this.props;

    return (
      <div className="cp-holds-pause-date-select">
        { enableStartDate && this.renderPauseStartDatePickerOverlay() }
        { enableEndDate && this.renderPauseEndDatePickerOverlay() }
      </div>
    );
  }
}

HoldsPauseDateSelect.defaultProps = {
  enableStartDate: false
};

HoldsPauseDateSelect.propTypes = {
  onSelectDates: PropTypes.func,
  enableStartDate: PropTypes.bool,
  enableEndDate: PropTypes.bool,
  initialSuspendStartDate: PropTypes.string,
  initialSuspendEndDate: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsPauseDateSelect/HoldsPauseDateSelect.jsx